import { Injectable } from "@angular/core";
import { FileUtilsService } from "src/app/shared/file-utils.service";
import { DatePipe } from "@angular/common";
import { BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import { ResultadoPaginado } from "src/app/model/resultado";
import { Aviso, TIPOS_AVISO } from "../../model/aviso.model";
import { AgenteFinanceiroService } from "./agente-financeiro.service";
import { AgenteFinanceiro } from "../../model/agente-financeiro.model";
import { BnPipeCnpj } from "@bndes/bndes-ux4/bn-mask2/cpfcnpj";
import { ProgramaRepasseBndes } from "src/app/model/programas-permitidos.model";
import { LimiteAgenteFinanceiro } from "src/app/model/limite-agente-financeiro.model";
import { ProtocoloArquivo, STATUS_PROTOCOLO } from "src/app/model/protocolo-arquivo.model";
import { DetalheConsultaEmpresa } from "src/app/model/protocolo-consulta-empresa.model";
import { InadimplenciaTecnica, TIPOS_BLOQUEIO } from "src/app/model/inadimplencia-tecnica.model";

const LIMITE_EXPORTACAO_CSV = 5000;

@Injectable({
    providedIn: 'root'
})
export class ExportService {
    private totalResultados: number = 0;
    private agentesFinanceiros: AgenteFinanceiro[] = [];
    private tiposAviso = TIPOS_AVISO;
    private tiposBloqueio = TIPOS_BLOQUEIO;
    constructor(
        private fileUtils: FileUtilsService,
        private datePipe: DatePipe,
        private loading: BnLoadingService,
        private bnAlertsService: BnAlertsService,
        private agenteFinanceiroService: AgenteFinanceiroService,
        private bnPipeCnpj: BnPipeCnpj,
    ) {
        agenteFinanceiroService.getAgentesFinanceiros()
            .subscribe((response) => {
                this.agentesFinanceiros = response;
        })
    }

    exportar(nome, csv) {
        if (this.totalResultados > LIMITE_EXPORTACAO_CSV) {
            this.bnAlertsService.alertaAviso('Atenção', 'A exportação está limitada às primeiras 5.000 operações. Utilize os filtros disponíveis para adequar a consulta.');
        }
        this.loading.liberaTela();
        this.fileUtils.exportarArquivo(nome, "\ufeff" + csv, FileUtilsService.TEXT_CSV);
    }

    exportarInadimplementos(resp: ResultadoPaginado<InadimplenciaTecnica>) {
        let lista = resp?.resultados || null;
        
        let csv = 'AGENTE FINANCEIRO;SIGLA;CNPJ;DATA INICIO;DATA FIM;MOTIVO;TIPO DE BLOQUEIO;DATA REGISTRO;DATA/HORA ATUALIZAÇÃO;USUÁRIO RESPONSÁVEL\n';
        this.totalResultados = resp.totalRegistrosSemPaginacao;
        console.log("total de registros para exportação: " + this.totalResultados);
        lista.forEach(item => {
            console.log("lista: " + item.agenteFinanceiro);
            csv += (this.agente(item.agenteFinanceiro)?.nome || 'TODOS') + ';'
            + (this.bnPipeCnpj.transform(this.agente(item.agenteFinanceiro)?.sigla) || 'TODOS') + ';'
            + (this.bnPipeCnpj.transform(this.agente(item.agenteFinanceiro)?.cnpj) || 'TODOS') + ';'
            + (this.formatarData(item?.dataInicio, true) || '') + ';'
            + (this.formatarData(item?.dataFim, true) || '') + ';'
            + (item?.motivo || '') + ';'
            + (this.labelTipoBloqueio(item.tipoBloqueio)) + ';'
            + (this.formatarData(item?.dataInsercao, true) || this.formatarData(item?.dataUltimaAtualizacao, true) || '') + ';'
            + (this.formatarData(item?.dataUltimaAtualizacao, true) || '') + ';'
            + (item?.nomeUsuarioInsercao || '') + '\n';
        });
        this.exportar('InadimplenciaTecnica.csv', csv);
    }

    exportarProgramas(resp: ProgramaRepasseBndes[]) {
        let lista = resp || null;
        let csv = 'CÓDIGOS DOS PROGRAMAS NO OPE;DESCRIÇÃO DO PROGRAMA;ESCO;USUÁRIO ATUALIZAÇÃO;DATA/HORA ATUALIZAÇÃO\n';
        this.totalResultados = resp.length;
        console.log("total de programas para exportação: " + this.totalResultados);
        lista.forEach(item => {
            csv += item.id + ';'
            + (item.descricaoPrograma || '') + ';'
            + (item.esco || 'N/A')  + ';'
            + (item?.usuarioUltimaAtualizacao || '') + ';'
            + (this.formatarData(item?.dataUltimaAtualizacao, true) || '') + '\n';
        });
        this.exportar('ProgramasPermitidos.csv', csv);
    }

    exportarListaAvisos(resp: ResultadoPaginado<Aviso>) {
        let lista = resp?.resultados || null;
        let csv = 'AGENTE FINANCEIRO;CNPJ;SIGLA;TITULO;TIPO AVISO;DATA PUBLÍCAÇÃO;ATIVO;USUÁRIO ATUALIZAÇÃO;DATA/HORA ATUALIZAÇÃO\n';
        this.totalResultados = resp.totalRegistrosSemPaginacao;
        console.log("total de avisos para exportacao: " + this.totalResultados);
        lista.forEach(item => {
            csv += (this.agente(item.agenteFinanceiroDestinatario)?.nome || 'TODOS') + ';'
            + (this.bnPipeCnpj.transform(this.agente(item.agenteFinanceiroDestinatario)?.cnpj) || 'TODOS') + ';'
            + (this.agente(item.agenteFinanceiroDestinatario)?.sigla || 'TODOS') + ';'
            + (item.titulo || '') + ';'
            + (this.labelTipoAviso(item.tipo)) + ';'
            + this.formatarData(item.dataCriacao, true) + ';'
            + ((item.avisoAtivo === 'S' ? 'Sim' : 'Não')) + ';'
            + (item?.nomeUsuarioDesativacao || item?.nomeUsuarioCriacao || '') + ';'
            + (this.formatarData(item?.dataDesativacao, true) || this.formatarData(item?.dataCriacao, true) || '') + '\n';
        });
        this.exportar('Avisos.csv', csv);
    }

    exportarListaLimites(resp: LimiteAgenteFinanceiro[], existeLimiteAgenteFinanceiroTranche: boolean, ehFGBS: boolean) {
        let lista = resp || null;
        let csv = 'AGENTE FINANCEIRO;CNPJ;SIGLA;LIMITE VIGENTE;VALOR UTILIZADO;VALOR DISPONIVEL\n';
        this.totalResultados = resp.length;
        console.log("total de limites para exportacao: " + this.totalResultados);
        lista.forEach(item => {
            let valorLimiteTotal = (!existeLimiteAgenteFinanceiroTranche || ehFGBS) ? 'N/A' : this.formatarMoeda(item.valorLimite.valorLimiteTotal);
            let valorLimiteDisponivel = (!existeLimiteAgenteFinanceiroTranche || ehFGBS) ? 'N/A' : this.formatarMoeda(item.valorLimite.valorLimiteDisponivel);

            csv += (item.agenteFinanceiro?.nome || '') + ';'
            + (this.bnPipeCnpj.transform(item.agenteFinanceiro?.cnpj) || '') + ';'
            + (item.agenteFinanceiro?.sigla || '') + ';'
            + (valorLimiteTotal || '') + ';'
            + (this.formatarMoeda(item.valorLimite.valorLimiteUtilizado) || '') + ';'
            + (valorLimiteDisponivel || '') + '\n';
        });
        this.exportar('Limites Contratacao.csv', csv);
    }

    exportarListaProtocolosRenuncia(resp: ResultadoPaginado<ProtocoloArquivo>) {
        let listaProtocolo = resp?.resultados || null;

        let csv = 'AGENTE FINANCEIRO;CNPJ;SIGLA;STATUS DA SOLICITAÇÃO;ID PROTOCOLO;USUARIO RESPONSAVEL;DATA/HORA SOLICITAÇÃO;SUBSTITUÍDO POR;DATA/HORA SUBSTITUIÇÃO \n';
        //this.totalResultados = resp.totalRegistrosSemPaginacao;
        //console.log("total de avisos para exportacao: " + this.totalResultados);
        listaProtocolo.forEach(item => {
            csv += item.nomeAgente + ';'
                + (this.bnPipeCnpj.transform(item.cnpjAgente))  + ';'
                + item.siglaAgente + ';'
                + STATUS_PROTOCOLO.filter(s => item.statusProtocolo == s.codigo)[0]?.label + ';'
                + item.idProtocoloNegocio + ';'
                + item.usuarioEnvio + ';'
                + this.formatarData(item.dataEnvio, true) + ';'
                + ( this.formatarEmMinusculo(item.usuarioSubstituicao) || '') + ';'
                + (this.formatarData(item.dataSubstituicao, true) || '') + '\n';

        });
        this.exportar('ProtocoloRenuncia.csv', csv);
    }

    exportarListaProtocolosEmpresa(listaProtocolo: DetalheConsultaEmpresa[]) {

        let csv = 'CNPJ; MOTIVO; ID PROTOCOLO; USUÁRIO SOLICITANTE; DATA/HORA SOLICITAÇÃO \n';
        
        listaProtocolo.forEach(item => {
            csv += item.cnpj + ';'
                + item.resultado + ';'
                + item.idProtocoloNegocio + ';'
                + item.usuarioEnvio + ';'
                + this.formatarData(item.dataEnvio, true) + '\n';
                
        });
        this.exportar('ProtocoloEmpresa.csv', csv);
    }

    formatarData(data: string | number | Date, comHora?: boolean) {
        const hora = comHora ? 'HH:mm:ss' : '';
        return data ? this.datePipe.transform(data, 'dd/MM/yyyy ' + hora) : '';
    }

    agente(id: number): AgenteFinanceiro {
        return this.agentesFinanceiros.filter(item => item.id == id)[0];
    }

    formatarEmMinusculo(valorEntrada: string){
        const valor = valorEntrada ? valorEntrada.toLowerCase() : '';
        return valor;
    }

    labelTipoAviso(codigo: number) {
        const tipos = this.tiposAviso.filter(item => item.codigo == codigo);
        return tipos.length > 0 ? tipos[0].label : `Tipo de aviso para código '${codigo}' desconhecido.`;
    }

    labelTipoBloqueio(codigo: string) {
        const tipos = this.tiposBloqueio.filter(item => item.codigo == codigo);
        return tipos.length > 0 ? tipos[0].label : `Tipo de bloqueio para código '${codigo}' desconhecido.`;
    }

    formatarMoeda(moeda) {
        if (!isNaN(moeda)) {
            return Number(moeda).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        }
        return '';
    }

}
